module.exports = __webpack_public_path__ + "static/media/previewlifestyle1-small.3d39427c.jpg";